module.exports = __webpack_public_path__ + "static/pinch_emoji-70220acb89a59a767557dc68e38dfb34.svg";